import React from "react";
import { Icon, Input } from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../../utilities/Constants";
import { Translation } from "react-i18next";
import scannerActions from "../../../flux/actions/ScannerAction";
import scannerListStore from "../../../flux/stores/scanner/ListStore";
import { IScannerViewData } from "../../../models/scanner/ScannerViewData";
import {
  ISidebarDetail,
  SidebarDetail,
} from "../../../models/shared/SidebarDetail";

interface ISidebarProps {
  // side bar collapse function
  onCollapseSidebar: () => void;
  // search value
  searchValue: string;
  // search functionality
  onSearch: (e: any) => void;
}

interface IState {
  listData: any;
}
export default class InstrumentSidebar extends React.Component<
  ISidebarProps,
  IState
> {
  private _listData: any = [];
  constructor(props: any) {
    super(props);
    this.state = {
      listData: [],
    };
  }

  getAllScannerData = () => {
    scannerActions
      .getAll(1, 0, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "%20")
      .then(() => {
        this.setState({
          listData: this._listData,
        });
      })
      .catch((e) => console.log("Error ", e));
  };

  componentDidMount() {
    this.getAllScannerData();
    scannerListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._listData = [];
      const data = state.data.result as IScannerViewData[];
      const items: ISidebarDetail[] = [];
      data.forEach((element) => {
        items.push(new SidebarDetail(element.id, element.name));
      });
      this._listData = items;
    });
  }

  render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="sidebar">
              <div className="container px-3 mb-2">
                <ul className="row nav sidebar-icons px-0 mx-0">
                  <li className="col-3 nav-item justify-content-center">
                    <button title={t("Collapse")}>
                      <Icon
                        name="abb/caret-left"
                        className="cursor-pointer"
                        sizeClass="large"
                        onClick={this.props.onCollapseSidebar}
                      />
                    </button>
                  </li>
                </ul>

                <div className="row px-0 mx-0 pr-3">
                  <div className="col-12 px-0 position-relative">
                    <Input
                      type="normal"
                      inputAttributes={{ autoFocus: "true" }}
                      dataType="text"
                      placeholder={t(CONSTANTS.LABEL_SEARCH)}
                      icon="abb/search"
                      value={this.props.searchValue}
                      onValueChange={this.props.onSearch}
                      className="ml-0"
                    />
                  </div>
                </div>
              </div>
              {this.props.children}
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
